<div class="container">
    <div class="semiCirculo"></div>
    <div class="wrapper">
        <div class="tituloEspera">
            <p>Esperá al médico, por favor...</p>
            <img src="../../../assets/img/wait_medic/medicos.png" alt="Icono de medicos">
        </div>
        <div class="imagenMedio">
            <img src="../../../assets/img/wait_medic/circulo_medio.png" alt="Carpeta de consulta medica">
            <p>Al finalizar la videoconsulta vas a poder descargar el <span>Informe Médico Digital</span> desde nuestra app URG Móvil.</p>
        </div>
    </div>
</div>